import { html } from "@nodusjs/std/dom";

export const component = () => html`<a><slot></slot></a>`;
